import axios from 'axios';
import { getTruncatedText } from '../../pages/MemberSummaryPage';
import properties from '../properties';

export interface TableColumns {
  Header: any;
  accessor: any;
  sticky?: string;
  cellType?: string;
  icon?: string | React.ReactNode | React.JSX.Element;
  Cell?: any;
}

export interface ActionData {
  action: string;
  typeOfStrategy: string;
  whatYouWantAchieve: string;
}

export interface CategoriesData {
  message: string;
  additionalData: string;
  actions: ActionData[];
  tableColumns: TableColumns[];
  tableData: any[];
}

export interface RecommendationsData {
  category: string;
  categoriesData: CategoriesData[];
}

export const getRecommendationsData = async (
  eg_nid: string[],
  category: string,
  recommendedTabStore: any,
  setRecommendationLoading?: any,
) => {
  if (setRecommendationLoading) {
    setRecommendationLoading(true);
  }
  await axios
    .post(properties.aiqBaseUrl + properties.recommendedScreen, {
      eg_nid: eg_nid,
      category: category,
    })
    .then((response) => {
      const data = response?.data?.data;
      const tempRecommendations: any[] = [];
      data?.map((item: any) => {
        const tempCategories: CategoriesData = {
          message: '',
          additionalData: '',
          actions: [],
          tableColumns: [],
          tableData: [],
        };
         
        item?.categories?.Strategy?.map((strategy: any) => {
          const tempActionsData: any = {
            action: '',
            typeOfStrategy: '',
            whatYouWantAchieve: '',
          };
          tempActionsData.action = strategy?.Action;
          tempActionsData.typeOfStrategy = strategy?.Type_of_strategy;
          tempActionsData.whatYouWantAchieve =
            strategy?.what_you_want_to_achieve;
          tempCategories.actions?.push(tempActionsData);
        });

        const tempColumnData = [];
        if (item?.categories?.column_name) {
          for (const [key, keyvalue] of Object.entries(
            item?.categories?.column_name,
          )) {
            const columnName: TableColumns = {
              Header: '',
              accessor: '',
            };
            columnName.Header = keyvalue;
            columnName.accessor = key;
            columnName.Cell = ({ value }: any) => {
              if (String(value).length > 30) {
                return getTruncatedText(value, '300px');
              }
              return value;
            };
            tempColumnData?.push(columnName);
          }
        }
        // data for internal pop up
        tempCategories.tableColumns = tempColumnData;
        tempCategories.tableData = item?.categories?.table;

        tempCategories.message = item?.categories?.Message;
        tempCategories.additionalData = item?.categories?.additional_data;
        const foundRecommendations = tempRecommendations.filter(
           
          (element) => element.category === item?.categories?.Category,
        );
        if (foundRecommendations.length === 0) {
          const newRecommendation: any = {
            category: '',
            categoriesData: [],
          };
          newRecommendation.category = item?.categories?.Category;
          newRecommendation.categoriesData?.push(tempCategories);
          tempRecommendations?.push(newRecommendation);
        } else {
          foundRecommendations[0]?.categoriesData?.push(tempCategories);
        }
      });
      recommendedTabStore?.setRecommendationsData(tempRecommendations);
      recommendedTabStore?.setTotalRecommendedCategories(
        tempRecommendations?.length,
      );
    })
    .catch((ex) => {
      return ex;
    })
    .then(() => {
      if (setRecommendationLoading) {
        setRecommendationLoading(false);
      }
    });
};

export const getRecommendationsDataForUtilizationMetrics = async (
  eg_nid: string[],
  category: string[],
  recommendedTabStore: any,
  setRecommendationLoading?: any,
) => {
  const totalRecommendations: any[] = [];
  if (setRecommendationLoading) {
    setRecommendationLoading(true);
  }
  category?.map(async (cat) => {
    await axios
      .post(properties.aiqBaseUrl + properties.recommendedScreen, {
        eg_nid: eg_nid,
        category: cat,
      })
      .then((response) => {
        const data = response?.data?.data;
         
        data?.map((item: any) => {
          const tempCategories: CategoriesData = {
            message: '',
            additionalData: '',
            actions: [],
            tableColumns: [],
            tableData: [],
          };
           
          item?.categories?.Strategy?.map((strategy: any) => {
            const tempActionsData: any = {
              action: '',
              typeOfStrategy: '',
              whatYouWantAchieve: '',
            };
            tempActionsData.action = strategy?.Action;
            tempActionsData.typeOfStrategy = strategy?.Type_of_strategy;
            tempActionsData.whatYouWantAchieve =
              strategy?.what_you_want_to_achieve;
            tempCategories.actions?.push(tempActionsData);
          });

          const tempColumnData = [];
          if (item?.categories?.column_name) {
            for (const [key, value] of Object.entries(
              item?.categories?.column_name,
            )) {
              const columnName: TableColumns = {
                Header: '',
                accessor: '',
              };
              columnName.Header = value;
              columnName.accessor = key;
               
              columnName.Cell = ({ value }: any) => {
                if (String(value).length > 30) {
                  return getTruncatedText(value, '300px');
                }
                return value;
              };
              tempColumnData?.push(columnName);
            }
          }
          // data for internal pop up
          tempCategories.tableColumns = tempColumnData;
          tempCategories.tableData = item?.categories?.table;

          tempCategories.message = item?.categories?.Message;
          tempCategories.additionalData = item?.categories?.additional_data;
          const foundRecommendations = totalRecommendations.filter(
             
            (element) => element.category === item?.categories?.Category,
          );
          if (foundRecommendations.length === 0) {
            const newRecommendation: any = {
              category: '',
              categoriesData: [],
            };
            newRecommendation.category = item?.categories?.Category;
            newRecommendation.categoriesData?.push(tempCategories);
            totalRecommendations?.push(newRecommendation);
          } else {
            foundRecommendations[0]?.categoriesData?.push(tempCategories);
          }
        });
        if (setRecommendationLoading) {
          setRecommendationLoading(false);
        }
      })
      .catch((ex) => {
        if (setRecommendationLoading) {
          setRecommendationLoading(false);
        }
        return ex;
      });
    recommendedTabStore?.setRecommendationsData(totalRecommendations);
    recommendedTabStore?.setTotalRecommendedCategories(
      totalRecommendations?.length,
    );
  });
};
